import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import getEnvConfig from 'utils/config/env';

export const analyticsRecommendationApi = createApi({
    reducerPath: 'analyticsRecommendation',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AnalyticsRecommendation'],
    endpoints: builder => ({
        createRecommendation: builder.mutation({
            query: community_id => ({
                method: 'POST',
                url: '/communities/recommendation',
                body: {
                    community_id: community_id,
                },
            }),
            transformResponse: (res: { data: string[] }) => res?.data,
        }),
    }),
});

export const { useCreateRecommendationMutation } = analyticsRecommendationApi;
